import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

export default function WeatherMetricTopicGroup({ topics }) {
  return (
    <div className="space-y-4">
      {topics.map((topic) => (
        <section key={topic.title} className="relative overflow-hidden rounded-[1.75rem] border border-cyan-200/35 bg-slate-950 p-3 shadow-2xl shadow-cyan-950/30 backdrop-blur-2xl ring-1 ring-cyan-100/15 before:pointer-events-none before:absolute before:inset-0 before:bg-[linear-gradient(135deg,rgba(34,211,238,0.14),transparent_42%,rgba(99,102,241,0.14))]">
          <div className="relative mb-3 flex flex-wrap items-center justify-between gap-2 px-1">
            <div>
              <p className="text-[11px] font-black uppercase tracking-[0.22em] text-cyan-200">{topic.eyebrow}</p>
              <h3 className="mt-1 text-lg font-black tracking-tight text-white">{topic.title}</h3>
            </div>
            <p className="max-w-sm text-sm font-medium leading-6 text-cyan-50/70">{topic.description}</p>
          </div>

          <div className="relative grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
            {topic.items.map((item) => {
              const Icon = item.icon;
              const content = (
                <Card className="h-full rounded-[1.25rem] border-cyan-200/35 !bg-slate-900 !text-white shadow-xl shadow-cyan-950/20 backdrop-blur-xl transition-colors hover:border-cyan-200/60 hover:!bg-slate-800">
                  <CardContent className="p-4">
                    <div className="flex items-start justify-between gap-4">
                      <div className="min-w-0">
                        <p className="text-xs font-black uppercase tracking-[0.18em] text-white/70">{item.label}</p>
                        <p className="mt-2 truncate font-mono text-2xl font-black tabular-nums text-white">{item.value}</p>
                        <p className="mt-1 line-clamp-2 text-sm font-medium text-white/75">{item.helper}</p>
                      </div>
                      <div className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-cyan-300/10 text-cyan-100 ring-1 ring-cyan-200/20 shadow-[0_0_22px_rgba(34,211,238,0.14)]">
                        <Icon className="h-5 w-5" />
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );

              return item.to ? (
                <Link key={item.label} to={item.to} className="block h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300 focus-visible:ring-offset-2">
                  {content}
                </Link>
              ) : (
                <div key={item.label}>{content}</div>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}